<template>
    <div class="container-fluid bg-primary" style="height:40px;" >
        <div class="container  p-0" style="position:relative;">
            <div class="card shadow-sm" style="position:absolute;top:0;width:100%;z-index:99;">
                <a class="bg-primary  text-light px-3 py-2 w-100 d-block" style="cursor:pointer;" data-toggle="collapse" data-target="#cate-menu" >
                    <i class="fas fa-bars pr-2"></i>Browse
                </a>
                <div id="cate-menu" class="collapse " >
                    <div class="card-body row  bg-light m-0 p-3 " style="min-height:500px;">
                        <div class="col-lg-3">
                            <sidebar-category/>
                            <sidebar-category-mobile/>
                        </div>

                        <div class="col-lg-9">
                            <search-bar/>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    import SidebarCategory from '@/Layouts/SidebarCategory'
    import SearchBar from '@/Layouts/SearchBar'
    import SidebarCategoryMobile from '@/Layouts/SidebarCategoryMobile'

export default {
     components: {
            SidebarCategory,
            SearchBar,
            SidebarCategoryMobile,
        },
    name: "ComponentBrowseDrawer",
}
</script>